module.exports = __webpack_public_path__ + "img/base_info.76b9450a.jpeg";